import { BarLineChart } from "@untitled-ui/icons-react";
import { type TFunction } from "i18next";

export default {
  name: "chart",
  priority: 3,
  icon: BarLineChart,
  menu: ({ t }: { t: TFunction }) => ({
    admin: [
      {
        label: t("Organization chart", { ns: "chart.shared" }),
        icon: <BarLineChart />,
        child: [
          {
            label: t("Structures", { ns: "chart.admin" }),
            to: "/admin/chart",
            permission: "chart.chart.view",
          },
          {
            label: t("Units", { ns: "chart.admin" }),
            to: "/admin/chart/operational/units",
            permission: "chart.chart-unit.view",
          },
          {
            label: t("Positions", { ns: "chart.admin" }),
            to: "/admin/chart/operational/positions",
            permission: "chart.chart-position.view",
          },
        ],
      },
    ],
  }),
} satisfies ModuleData;
